import { createFileRoute } from '@tanstack/react-router';
import { AdminFuelSurchargePage } from '@/features/admin/admin-fuel-surcharge-page';

type FuelSurchargeTabSearch = {
  tab?: 'global' | 'organization';
};

export const Route = createFileRoute('/admin/fuel-surcharge/')({
  validateSearch: (raw: Record<string, unknown>): FuelSurchargeTabSearch => {
    const tab = raw.tab;
    if (tab === 'organization' || tab === 'global') {
      return { tab };
    }
    return {};
  },
  component: FuelSurchargeIndexRoute,
});

function FuelSurchargeIndexRoute() {
  return <AdminFuelSurchargePage />;
}
